import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-armenia-page',
  templateUrl: './armenia-page.component.html',
  styleUrls: ['./armenia-page.component.css']
})
export class ArmeniaPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
